// extracted by mini-css-extract-plugin
export default {"countryFlag":"Oqkee2R"};